import { Api } from "@/api";
import { Context } from "@/services/context.ts";

export const MAIN_LISTENER_NAME = "main";

export class Main {
  constructor(
    protected context: Context,
    protected api: Api,
  ) {
    this.update();
  }

  private update = () => {
    this.context.notify(MAIN_LISTENER_NAME);
  };

  private get value() {
    return {
      ...this,
    };
  }
}
